import {
  QboCandidates,
  QboExportPreview,
  type QboExportRequest,
  type QboMappingsRequest,
  QboMappingsResponse,
  QboQueuedResponse,
  type QboSettingsPatch,
  QboStatus,
  QboSyncLog,
  QboSyncLogsResponse,
} from '@siteday/shared';

import { api, buildUrl } from './client';

/**
 * QuickBooks Online (doc 05 "QuickBooks", doc 10; W10). Every payload is the
 * shared Zod contract from `@siteday/shared` — the same schemas the API
 * validates with.
 */
export type {
  QboCandidate,
  QboCandidates,
  QboExportPreview,
  QboExportPreviewEntry,
  QboExportPreviewRow,
  QboExportRequest,
  QboLineStatus,
  QboMappingsRequest,
  QboSettingsPatch,
  QboStatus,
  QboSyncFailure,
  QboSyncLog,
} from '@siteday/shared';

export const getStatus = () => api.get('/quickbooks/status', QboStatus);
export const patchSettings = (patch: QboSettingsPatch) =>
  api.patch('/quickbooks/settings', patch, QboStatus);
export const getCandidates = () => api.get('/quickbooks/candidates', QboCandidates);
export const putMappings = (m: QboMappingsRequest) =>
  api.put('/quickbooks/mappings', m, QboMappingsResponse);
export const runImport = () => api.post('/quickbooks/import', undefined, QboQueuedResponse);
export const runExport = (scope: QboExportRequest) =>
  api.post('/quickbooks/export', scope, QboQueuedResponse);
export const getExportPreview = (scope: QboExportRequest) =>
  api.get('/quickbooks/export/preview', QboExportPreview, {
    jobId: scope.jobId,
    weekStart: scope.weekStart,
  });
export const getLogs = () =>
  api.get('/quickbooks/logs', QboSyncLogsResponse).then((r) => r.items);
export const getLog = (id: string) => api.get(`/quickbooks/logs/${id}`, QboSyncLog);
export const retryFailed = (logId: string) =>
  api.post(`/quickbooks/logs/${logId}/retry`, {}, QboQueuedResponse);
export const disconnect = () => api.post('/quickbooks/disconnect', undefined);
/** OAuth starts with a top-level navigation to the API (302 to Intuit, doc 10). */
export const connectUrl = () => buildUrl('/quickbooks/connect');
/** Mock-only: the same route answered by MSW flips the mock tenant to "connected". */
export const connectViaFetch = () => api.get('/quickbooks/connect');
